{
	"language": {
		"aria": "Change language"
	},
	"placeholder": {
		"title": "Your candidate centre is on its way",
		"body": "There's nothing here yet. We'll send you a link by email once it's ready."
	},
	"not_found": {
		"title": "Page not found",
		"body": "Check the link you followed, or use the link from your email."
	},
	"error_boundary": {
		"reload": "Reload page"
	},
	"login": {
		"loading": "Loading…",
		"title": "Sign in to your candidate centre",
		"intro": "Enter your email address to see your applications.",
		"email_label": "Email address",
		"email_placeholder": "you@example.com",
		"submit": "Login",
		"sending": "Sending…",
		"sent": {
			"title": "Check your email",
			"body": "If {{email}} matches an application, a sign-in link is on its way.",
			"retry": "Didn't get it? Check the address and try again"
		},
		"resent": {
			"title": "We've sent you a new sign-in link",
			"body": "The link you opened has expired. If your email matches an application, a new sign-in link is on its way. It opens the same page.",
			"request_manually": "Didn't get it? Request a new link"
		},
		"request_error": {
			"throttled": "Too many attempts. Please wait a minute and try again.",
			"invalid_email": "Please enter a valid email address.",
			"generic": "Something went wrong. Please try again."
		},
		"unknown_organisation": {
			"title": "Page not found",
			"body": "Check the link you followed, or use the link from your email."
		},
		"error": {
			"title": "Something went wrong",
			"body": "We couldn't load this page. Please try again in a moment."
		}
	},
	"organisations": {
		"title": "Your applications",
		"intro": "Choose a company to see the applications you've sent them.",
		"count_one": "{{count}} submission",
		"count_other": "{{count}} submissions",
		"empty": {
			"title": "No applications yet",
			"body": "Once you apply to a company, it'll show up here."
		},
		"error": "We couldn't load your companies. Please try again in a moment.",
		"log_out": "Log out",
		"logging_out": "Logging out…"
	},
	"submissions": {
		"title": "Past submissions",
		"back_to_organisations": "All companies",
		"cv_uploaded": "CV uploaded",
		"empty": {
			"title": "No submissions yet",
			"body": "Applications you send to {{organisation}} will show up here."
		},
		"error": "We couldn't load your submissions. Please try again in a moment.",
		"log_out": "Log out",
		"logging_out": "Logging out…"
	},
	"profile": {
		"link": {
			"title": "Your profile",
			"cv_added": "CV added",
			"cv_missing": "No CV yet"
		},
		"back": "Back to application",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "You're happy to be contacted about this job.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Upload your CV",
				"drop_hint": "or drag and drop it here",
				"constraints": "{{types}}, up to {{size}} MB",
				"uploading": "Uploading {{fileName}}…",
				"done": "CV uploaded",
				"error_type": "This file type isn't supported. Allowed types: {{types}}.",
				"error_size": "This file is too large. The maximum size is {{size}} MB."
			},
			"remove": {
				"label": "Remove {{fileName}}",
				"question": "Remove {{fileName}}?",
				"consequence": "The employer will no longer be able to see it. This can't be undone.",
				"confirm": "Remove CV",
				"cancel": "Cancel",
				"removing": "Removing…",
				"error": "Couldn't remove your CV. Try again."
			}
		},
		"work_history": {
			"title": "Work history",
			"description": "Tell us about any relevant work history: where you worked, what you did there, and how long you worked there. You can add more than one job if they're relevant.",
			"placeholder": "Describe a job you've had",
			"input_label": "Job details",
			"save": "Save",
			"saving": "Saving…",
			"cancel": "Cancel",
			"edit": "Edit",
			"remove": "Remove",
			"add_another": "Add another job",
			"error_empty": "Write something before saving.",
			"error_limit": "You can add up to {{max}} jobs.",
			"unsaved_changes": "You have unsaved changes to your work history. Leave anyway and lose them?",
			"hints": {
				"label": "Details in this job",
				"included": "included",
				"missing": "not mentioned yet"
			}
		},
		"education": {
			"title": "Education",
			"description": "Tell us about any relevant education: what you studied, where you studied, and when. Degrees, schools, courses and certificates all count. You can add more than one.",
			"placeholder": "Describe a degree, school or course",
			"input_label": "Education details",
			"save": "Save",
			"saving": "Saving…",
			"cancel": "Cancel",
			"edit": "Edit",
			"remove": "Remove",
			"add_another": "Add more education",
			"error_empty": "Write something before saving.",
			"error_limit": "You can add up to {{max}} education entries.",
			"unsaved_changes": "You have unsaved changes to your education. Leave anyway and lose them?"
		},
		"licenses": {
			"title": "Licences and certifications",
			"description": "Tell us about any licences or certifications you have, such as a driving licence, forklift licence or hygiene passport. Add when you got it, and when it expires if it does. You can add more than one.",
			"placeholder": "Describe a licence or certification",
			"input_label": "Licence details",
			"save": "Save",
			"saving": "Saving…",
			"cancel": "Cancel",
			"edit": "Edit",
			"remove": "Remove",
			"add_another": "Add another licence",
			"error_empty": "Write something before saving.",
			"error_limit": "You can add up to {{max}} licences.",
			"unsaved_changes": "You have unsaved changes to your licences. Leave anyway and lose them?"
		}
	},
	"submission": {
		"back": "Back to my submissions",
		"back_short": "Back",
		"not_found": {
			"title": "Submission not found",
			"body": "This submission doesn't exist, or it isn't one of yours."
		},
		"result": {
			"heading": "The confirmation screen you saw after applying"
		},
		"summary": {
			"title": "Summary of your answers",
			"submitted_on": "You submitted this form on",
			"submitted_more_than_once": "You filled out this form more than once. We'll automatically merge your profile; the submission below is the latest."
		}
	},
	"removal_request": {
		"title": "Data removal request",
		"loading": "Loading your request…",
		"not_found_title": "Request not found",
		"not_found_body": "This link may have expired or is invalid. Check the link from your email.",
		"confirm_heading": "Confirm data removal",
		"confirm_body": "You are requesting that {{companyName}} remove your personal data.",
		"confirm_button": "Confirm removal request",
		"confirmed_title": "Request confirmed",
		"confirmed_body": "Your data removal request has been submitted. The company will process it shortly.",
		"already_handled": "This request has already been processed.",
		"error": "Something went wrong. Please try again later.",
		"conflict": "This request was already confirmed."
	}
}
